/* Extracted from legacy/tweaks-panel.jsx:140 — keeps responsive
   conditional rendering working in the migrated screens.
   Phase 7-followup: rewritten using useSyncExternalStore so it doesn't
   trigger the set-state-in-effect lint rule. Same external source
   (window.matchMedia), same observable behaviour. */

import { useCallback, useSyncExternalStore } from "react";

function getServerSnapshot(): boolean {
  return false;
}

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (callback: () => void) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => undefined;
      const mql = window.matchMedia(query);
      if (mql.addEventListener) {
        mql.addEventListener("change", callback);
        return () => mql.removeEventListener("change", callback);
      }
      // Safari < 14 fallback
      mql.addListener(callback);
      return () => mql.removeListener(callback);
    },
    [query],
  );
  const getSnapshot = useCallback(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  }, [query]);
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
